import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "as-lineups" }
const _hoisted_2 = { class: "as-team" }
const _hoisted_3 = { class: "as-team-item" }
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = { class: "as-name" }
const _hoisted_6 = { class: "as-team-item as-team-item-away" }
const _hoisted_7 = { class: "as-name" }
const _hoisted_8 = ["src", "alt", "title"]
const _hoisted_9 = { class: "as-content" }
const _hoisted_10 = { class: "as-lineup-item-left as-d-flex as-flex-column as-justify-content-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "as-player-name" }
const _hoisted_13 = { class: "as-line-box" }
const _hoisted_14 = { class: "as-line1" }
const _hoisted_15 = { class: "as-line2" }
const _hoisted_16 = { class: "as-points" }
const _hoisted_17 = { class: "as-lineup-item-right as-d-flex as-flex-column as-justify-content-center" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "as-player-name" }

import { ref, computed } from "vue";
import type { ILineups, IMatch, IPlayer } from "~src/interfaces/basketball";
import { getTotalScore } from "~src/helpers/basketball";
import { convertLineupsPlayer } from "~src/helpers/basketball/LineupHelper";


const __default__ = {};

interface IProps {
  lineups: ILineups;
  match: IMatch;
}

interface IData {
  title: string;
  home: number;
  away: number;
  home_player_id: string | null;
  home_player_name: string | null;
  away_player_id: string | null;
  away_player_name: string | null;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'LineupTab',
  props: {
    lineups: {},
    match: {}
  },
  setup(__props: any) {

const props = __props;

const getParcent = (homeVal: number, awayVal: number) => {
  const total: number = homeVal + awayVal;

  const rsHome = ((homeVal / total) * 100).toFixed();
  const rsAway = ((awayVal / total) * 100).toFixed();

  return {
    home: rsHome,
    away: rsAway,
  };
};

const datas = computed(() => {
  const items: IData[] = [
    {
      title: "Điểm",
      home: 0,
      away: 0,
      home_player_id: null,
      home_player_name: null,
      away_player_id: null,
      away_player_name: null,
    },
    {
      title: "Bắt bóng bật bảng",
      home: 0,
      away: 0,
      home_player_id: null,
      home_player_name: null,
      away_player_id: null,
      away_player_name: null,
    },
    {
      title: "Đường chuyền kiến tạo",
      home: 0,
      away: 0,
      home_player_id: null,
      home_player_name: null,
      away_player_id: null,
      away_player_name: null,
    },
  ];

  if(props.lineups.players) {
    for (const player of props.lineups.players.home) {
      if(items[0].home === 0 || player.data.score > items[0].home) {
        items[0].home = player.data.score;
        items[0].home_player_id = player.id;
        items[0].home_player_name = player.name;
      }
      if(items[1].home === 0 || player.data.total_rebounds > items[1].home) {
        items[1].home = player.data.total_rebounds;
        items[1].home_player_id = player.id;
        items[1].home_player_name = player.name;
      }
      if(items[2].home === 0 || player.data.assists > items[2].home) {
        items[2].home = player.data.assists;
        items[2].home_player_id = player.id;
        items[2].home_player_name = player.name;
      }
    }
    for (const player of props.lineups.players.away) {
      if(items[0].away === 0 || player.data.score > items[0].away) {
        items[0].away = player.data.score;
        items[0].away_player_id = player.id;
        items[0].away_player_name = player.name;
      }
      if(items[1].away === 0 || player.data.total_rebounds > items[1].away) {
        items[1].away = player.data.total_rebounds;
        items[1].away_player_id = player.id;
        items[1].away_player_name = player.name;
      }
      if(items[2].away === 0 || player.data.assists > items[2].away) {
        items[2].away = player.data.assists;
        items[2].away_player_id = player.id;
        items[2].away_player_name = player.name;
      }
    }
  }

  return items;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.getImgUrlBySport('team', _ctx.match?.home_team?.id),
          alt: _ctx.match?.home_team?.name,
          title: _ctx.match?.home_team?.name
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.match?.home_team?.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.match?.away_team?.name), 1),
        _createElementVNode("img", {
          src: _ctx.getImgUrlBySport('team', _ctx.match?.away_team?.id),
          alt: _ctx.match?.away_team?.name,
          title: _ctx.match?.away_team?.name
        }, null, 8, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "as-lineup-item"
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: item.home_player_id ? _ctx.getImgUrlBySport('player', item.home_player_id) : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAq1BMVEUAAADz+//y+//////z+//y+v/z+v/z+//z+//z+v/0+//z/P/4///z///y+v/c5/T79e7u9v54krz269/m7/nj7vjs9fzf6vbr8fjp8Pfp8vvt6uiDm8G8xdewvNKfsMt8lr7z9fXO2OePpMbu7/Dy7uvn5uemt9Gks8yUqMmZq8jz+Pvc5vDY4u/18On17ubi4uXE0eXw6eLEzNq2xdrY2uDN0t3W09S+ws6rjEyiAAAADnRSTlMAgPML6NnTv6qlclIjFjy9diYAAAH+SURBVDjLnZXpeqsgEEDV7NsgCGLUGNM0a3vb3rZ3ef8nKxBwoPvX80vhMAMIYxQyn05GgyQZjCbTefQhi3gICqoAxTBevKv14gQgF8QicoAk7r31Zn2gXAu8zPOSC/1IoT977cUA3IRxmGEcIA7TjoFKHSGACiIpjP30Y8gJwWio6taxn5fqsRfEYXt6ps6UJMfsM+3ZHn5ihsapklCY2Qn2zZvhV8ssdd5lh37PJuYktx5DanAmvyRfJECEbTywdmus9ZGxKzdpQpOFDUjt4Jo9pNVTs3pI07/s3IUUJuQQA96yVdpxZNQtkMBQnRfIux28qlNkz3gXsoR5NNUDnLhOPWqXSKecRhOQohMbXzxx6JYDk2gExDVssp0vVtkGJzmKBihmWRqQ3duOktBBlKipfiRmYNDLTT4V7zzRT31zH4p3N15qXIxmta6cpR4BvMUE2wPP7MmJdbsBf3uCDQfZ1vuL17ADgL/h+AkNv1m72qe7P2e2NY34Ce2hQLNmhrVpw0OBx8xR/T9uz80/N0E8ZnhwDWWVGa5LgODghleB82JnxUKU3lUILxcVxXJ5fRHV01Lg5QquK5WqV5JH7VVEvRQSr6tXALSnq9Tto/YUBS8EFgAsKbqDBKgEWFK8IiWd55BLLFJh2XtFWPbCQopgIf1Zaf662H/79/ECjIFUYeI1OcEAAAAASUVORK5CYII=',
              class: "as-player-img"
            }, null, 8, _hoisted_11),
            _createElementVNode("div", _hoisted_12, _toDisplayString(item.home_player_name), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "as-line1-text",
                style: _normalizeStyle({
              bottom: item.home > 0 || item.away > 0 ? `${item.home + 5}px` : ''
            })
              }, _toDisplayString(item.home > 0 || item.away > 0 ? item.home : ''), 5),
              _createElementVNode("div", {
                class: "as-line1-bar",
                style: _normalizeStyle({
              height: item.home > 0 || item.away > 0 ? `${item.home}px` : ''
            })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "as-line1-text",
                style: _normalizeStyle({
              bottom: item.home > 0 || item.away > 0 ? `${item.away + 5}px` : ''
            })
              }, _toDisplayString(item.home > 0 || item.away > 0 ? item.away : ''), 5),
              _createElementVNode("div", {
                class: "as-line2-bar",
                style: _normalizeStyle({
              height: item.home > 0 || item.away > 0 ? `${item.away}px` : ''
            })
              }, null, 4)
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "as-line3" }, null, -1)),
            _createElementVNode("div", _hoisted_16, _toDisplayString(item.title), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              src: item.away_player_id ? _ctx.getImgUrlBySport('player', item.away_player_id) : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAq1BMVEUAAADz+//y+//////z+//y+v/z+v/z+//z+//z+v/0+//z/P/4///z///y+v/c5/T79e7u9v54krz269/m7/nj7vjs9fzf6vbr8fjp8Pfp8vvt6uiDm8G8xdewvNKfsMt8lr7z9fXO2OePpMbu7/Dy7uvn5uemt9Gks8yUqMmZq8jz+Pvc5vDY4u/18On17ubi4uXE0eXw6eLEzNq2xdrY2uDN0t3W09S+ws6rjEyiAAAADnRSTlMAgPML6NnTv6qlclIjFjy9diYAAAH+SURBVDjLnZXpeqsgEEDV7NsgCGLUGNM0a3vb3rZ3ef8nKxBwoPvX80vhMAMIYxQyn05GgyQZjCbTefQhi3gICqoAxTBevKv14gQgF8QicoAk7r31Zn2gXAu8zPOSC/1IoT977cUA3IRxmGEcIA7TjoFKHSGACiIpjP30Y8gJwWio6taxn5fqsRfEYXt6ps6UJMfsM+3ZHn5ihsapklCY2Qn2zZvhV8ssdd5lh37PJuYktx5DanAmvyRfJECEbTywdmus9ZGxKzdpQpOFDUjt4Jo9pNVTs3pI07/s3IUUJuQQA96yVdpxZNQtkMBQnRfIux28qlNkz3gXsoR5NNUDnLhOPWqXSKecRhOQohMbXzxx6JYDk2gExDVssp0vVtkGJzmKBihmWRqQ3duOktBBlKipfiRmYNDLTT4V7zzRT31zH4p3N15qXIxmta6cpR4BvMUE2wPP7MmJdbsBf3uCDQfZ1vuL17ADgL/h+AkNv1m72qe7P2e2NY34Ce2hQLNmhrVpw0OBx8xR/T9uz80/N0E8ZnhwDWWVGa5LgODghleB82JnxUKU3lUILxcVxXJ5fRHV01Lg5QquK5WqV5JH7VVEvRQSr6tXALSnq9Tto/YUBS8EFgAsKbqDBKgEWFK8IiWd55BLLFJh2XtFWPbCQopgIf1Zaf662H/79/ECjIFUYeI1OcEAAAAASUVORK5CYII=',
              class: "as-player-img"
            }, null, 8, _hoisted_18),
            _createElementVNode("div", _hoisted_19, _toDisplayString(item.away_player_name), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})